export default {
  title: {
    create: 'Create New Product',
    detail: 'Details',
    history: 'Stock History',
    editCategory: 'Edit Product Category',
    editType: 'Edit Product Type',
    receipt: 'Receipt'
  },
  headers: {
    no: 'Product Code',
    name: 'Product Name',
    category: 'Category',
    productCategory: 'Product Category',
    type: 'Type',
    status: 'Status',
    sale: 'Sale'
  },
  label: {
    nameTh: 'Product Name',
    nameEn: 'Product Name (EN)',
    nameCn: 'Product Name (CN)',
    category: 'Category',
    selectedProduct: 'Selected Product',
    productCategory: 'Product Category',
    categoryName: 'Product Category Name',
    description: 'Description',
    mexDescription: '(No more than 2,000 characters)',
    type: 'Type',
    productType: 'Product Type',
    productTypeName: 'Product Type Name',
    unit: 'Product Unit',
    unitName: 'Unit Name',
    remainingStock: 'Remaining Stock',
    unitIn: 'Import Unit',
    subUnit: 'Sub Unit',
    subUnitPer: 'Sub Unit Quantity per Import Unit',
    minQty: 'Minimum Quantity (Import Unit)',
    maxQty: 'Maximum Quantity (Import Unit)',
    detail: 'Details',
    howToUse: 'How to Use',
    timeUse: 'Usage Time',
    preserve: 'Storage Instructions',
    properties: 'Properties',
    guide: 'Guidance',
    sale: 'Sale',
    pricePerUnit: 'Purchase Price per Unit',
    buyPrice: 'Purchase Price',
    salePrice: 'Sale Price',
    productPrice: 'Product Sale Price',
    haveVAT: 'With VAT',
    noVAT: 'Without VAT',
    typeVAT: 'VAT Type',
    sumVAT: 'VAT included in product price',
    noSumVAT: 'VAT calculated separately from product price',
    startPrice: 'Starting Price',
    priceBeforeVat: 'Price Before VAT',
    sumInProductPrice: 'Included in product price',
    noSumInProductPrice: 'Excluded from product price',
    commission: 'Commission',
    haveCommission: 'With Commission',
    noCommission: 'No Commission',
    note1: 'Note: The commission entered will be deducted from the product sale price',
    note2: 'and used for commission sharing with product sellers',
    bath: 'Baht',
    profit: 'Profit',
    discount: 'Discount',
    treatmentFee: 'Treatment Fee',
    maxDescription: '( 200-2,000 text )',
    backToPOS: 'Back to Cashier',
    receiptId: 'Receipt Id'
  },
  placeholder: {
    nameTh: 'Enter Product Name',
    nameEn: 'Enter Product Name in English',
    nameCn: 'Enter Product Name in Chinese',
    category: 'Select Category',
    enterUnitInfo: 'Enter Unit Information',
    unitName: 'Enter Unit Name',
    unitIn: 'Select Import Unit',
    productType: 'Enter Product Type Information',
    productTypeName: 'Enter Product Type Name',
    subUnit: 'Select Sub Unit',
    subUnitPer: 'Sub Unit Quantity per Import Unit',
    minQty: 'Enter Minimum Quantity',
    maxQty: 'Enter Maximum Quantity',
    detail: 'Details',
    howToUse: 'Enter Usage Instructions (shown on label)',
    timeUse: 'Enter Usage Time (shown on label)',
    preserve: 'Enter Storage Instructions',
    properties: 'Enter Properties (shown on label)',
    guide: 'Guidance (shown on label)',
    sale: 'Sale',
    pricePerUnit: 'Enter Purchase Price',
    buyPrice: 'Purchase Price',
    salePrice: 'Enter Price',
    productPrice: 'Product Sale Price',
    haveVAT: 'With VAT',
    noVAT: 'Without VAT',
    typeVAT: 'VAT Type',
    sumVAT: 'VAT included in product price',
    noSumVAT: 'VAT calculated separately from product price',
    startPrice: 'Starting Price',
    priceBeforeVat: 'Price Before VAT',
    sumInProductPrice: 'Included in product price',
    noSumInProductPrice: 'Excluded from product price',
    commission: 'Commission',
    haveCommission: 'With Commission',
    noCommission: 'No Commission',
    note1: 'Note: The commission entered will be deducted from the product sale price',
    note2: 'and used for commission sharing with product sellers',
    bath: 'Baht',
    profit: 'Profit',
    searchIdName: 'Search Product Code, Product Name',
    searchProductUnitName: 'Search Unit Name',
    productCategory: 'Enter Product Category',
    info: 'Enter Product Category Information',
    productUnitUpdateSuccess: 'Product Unit updated successfully!',
    confirmDeleteProductUnit: 'Confirm deletion of product unit',
    categoryName: 'Enter Product Category Name',
    description: 'Enter Product Category Description',
    typeDescription: 'Enter Product Type Description',
    searchProductCategory: 'Search Product Category Name',
    searchProductType: 'Search Product Type Name',
    treatmentFee: 'Enter Product Treatment Fee'
  },
  statusProduct: {
    belowControl: 'Below Control Quantity',
    withinControl: 'Within Control Quantity',
    aboveControl: 'Above Control Quantity'
  },
  toolTip: {
    see: 'View Product Information',
    create: 'Create New Product',
    edit: 'Edit Information',
    duplicate: 'Duplicate Information',
    delete: 'Delete Information'
  },
  modal: {
    deleteConfirm: 'Confirm Product Deletion',
    deleteDelete: 'You are deleting a product. Do you want to continue?',
    create: {
      category: {
        success: 'Product category added successfully!'
      },
      type: {
        success: 'Product type added successfully!'
      },
      unit: {
        success: 'Product unit added successfully!'
      }
    },
    edit: {
      category: {
        success: 'Product category edited successfully!'
      },
      type: {
        success: 'Product type edited successfully!'
      }
    },
    delete: {
      category: {
        title: 'Confirm Product Category Deletion',
        subTitle: 'You are deleting a product category. Do you want to continue?',
        success: 'Product category deleted successfully!'
      },
      type: {
        title: 'Confirm Product Type Deletion',
        subTitle: 'You are deleting a product type. Do you want to continue?',
        success: 'Product type deleted successfully!'
      }
    }
  },
  alert: {
    deleted: 'Product deleted successfully'
  }
}
